// extracted by mini-css-extract-plugin
var _1 = "s4Rx8";
export { _1 as "productPicker" }
